import React, {
    useState,
    useEffect
}
from "react";

import {
    useHistory
}
from "react-router-dom";

import {
    functions
}
from "../../../constants/common-functions";

import HomeBox
from "../components/HomeBox";

import {
    OMNISCAN_BLUE,
    OMNISCAN_BLUE_RGB
}
from "../../../constants/colors";


export default function HomeBoxMyTasks({
    isMobile
})
{

    //--------------------------------------------------------
    // Router
    //--------------------------------------------------------

    const history =
        useHistory();


    //--------------------------------------------------------
    // State
    //--------------------------------------------------------

    const [completed, setCompleted] =
        useState(0);

    const [inProgress, setInProgress] =
        useState(0);

    const [notStarted, setNotStarted] =
        useState(0);

    const [overdue, setOverdue] =
        useState(0);


    //--------------------------------------------------------
    // Load counts
    //--------------------------------------------------------

    useEffect(
        () =>
        {

            functions.getObjectFromAjax(

                "/resolutionsoftwareplatform//home/resources/counts",

                null,

                populateCounts
            );

        },
        []
    );


    //--------------------------------------------------------
    // Populate counts
    //--------------------------------------------------------

    const populateCounts =
        (obj) =>
        {

            console.log(
                "Home Counts"
            );

            console.log(
                obj
            );

        };


    //--------------------------------------------------------
    // Navigation
    //--------------------------------------------------------

    const clickFunction =
        () =>
        {

            history.push(
                "/workflow/list"
            );

        };


    //========================================================
    // Styles
    //========================================================

	const container =
	{
	    display:
	        "flex",

	    flexDirection:
	        "column",

	    width:
	        "100%",

	    boxSizing:
	        "border-box",

	    padding:
	        "0px 10px 10px 10px"
	};



	//========================================================
	// Title
	//========================================================

	const titleContainer =
	{
	    display:
	        "flex",

	    justifyContent:
	        "flex-start",

	    alignItems:
	        "center",

	    height:
	        "40px",

	    paddingLeft:
	        "0px",

	    flexShrink:
	        0,

	    fontSize:
	        "14px",

	    fontWeight:
	        600,

	    color:
	        "#263746",

	    letterSpacing:
	        "0.1px"
	};


    //--------------------------------------------------------
    // KPI rows
    //--------------------------------------------------------

	const grid =
	{
	    display:
	        "flex",

	    flexWrap:
	        "wrap",

	    width:
	        "100%",

	    gap:
	        "8px",

	    boxSizing:
	        "border-box"
	};


	const box =
	{
	    display:
	        "flex",

	    width:
	        "calc(50% - 4px)",

	    height:
	        "38px",

	    background:
	        "rgba(248,250,252,0.82)",

	    border:
	        "1px solid rgba(12,53,88,0.10)",

	    borderRadius:
	        "0px",

	    boxShadow:
	        "none",

	    alignItems:
	        "stretch",

	    boxSizing:
	        "border-box",

	    overflow:
	        "hidden"
	};


    //--------------------------------------------------------
    // KPI labels
    //--------------------------------------------------------

    const label =
    {

        display:
            "flex",

        flex:
            1,

        alignItems:
            "center",

        paddingLeft:
            "14px",

        paddingRight:
            "10px",

        fontSize:
            "13px",

        fontWeight:
            500,

        color:
            "#465564"
    };


    //--------------------------------------------------------
    // KPI figures
    //--------------------------------------------------------

    const figureBase =
    {

        width:
            "72px",

        minHeight:
            "38px",

        display:
            "flex",

        justifyContent:
            "center",

        alignItems:
            "center",

        borderRadius:
            "0px",

        fontSize:
            "15px",

        fontWeight:
            700,

        color:
            "#ffffff",

        flexShrink:
            0
    };


    const greenBg =
    {

        background:
            "#2f9b58"

    };


    const amberBg =
    {

        background:
            "#ee9a20"

    };


    const redBg =
    {

        background:
            "#c92332"

    };


    //========================================================
    // Render
    //========================================================

    return (

        <HomeBox

            isMobile={isMobile}

            isLive={true}

            title="For Me"

            color={OMNISCAN_BLUE}

            colorRgb={OMNISCAN_BLUE_RGB}

            clickFunction={clickFunction}

            icon="user"

            delay={600}

        >

            <div style={container}>

                {/* ==========================================
                    TITLE
                =========================================== */}

                <div style={titleContainer}>

                    Personal Tasks & Workflow

                </div>


                {/* ==========================================
                    TASK KPIs
                =========================================== */}

                <div style={grid}>

                    {/* Completed */}

                    <div style={box}>

                        <div style={label}>

                            Completed

                        </div>

                        <div
                            style={{
                                ...figureBase,
                                ...greenBg
                            }}
                        >

                            {
                                functions.formatNumber(
                                    completed,
                                    0
                                )
                            }

                        </div>

                    </div>


                    {/* In Progress */}

                    <div style={box}>

                        <div style={label}>

                            In Progress

                        </div>

                        <div
                            style={{
                                ...figureBase,
                                ...amberBg
                            }}
                        >

                            {
                                functions.formatNumber(

                                    (Number(inProgress) || 0)
                                    +
                                    (Number(notStarted) || 0),

                                    0
                                )
                            }

                        </div>

                    </div>


                    {/* Overdue */}

                    <div style={box}>

                        <div style={label}>

                            Overdue

                        </div>

                        <div
                            style={{
                                ...figureBase,
                                ...redBg
                            }}
                        >

                            {
                                functions.formatNumber(
                                    overdue,
                                    0
                                )
                            }

                        </div>

                    </div>

                </div>

            </div>

        </HomeBox>

    );

}